export class MedicareBasedConfig{
    basedOnMedicare:boolean = false;
    percentOfMedicare:number = 0;
    inpatientConversionFactor:number = 0;
    outpatientConversionFactor:number = 0;
    medicareContractId:string = '';

}